import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-422690ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Edit Manajemen Harga"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, " Edit Manajemen Harga ")
], -1))
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = { class: "card col-lg-8 border" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "col-lg-12 row" }
const _hoisted_10 = { class: "col-lg-12 fv-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Price title", -1))
const _hoisted_12 = { class: "col-lg-12 fv-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Deskripsi", -1))
const _hoisted_14 = { class: "col-lg-12 fv-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, " Price Type", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, " -- Select (Free, Recurring, Fixed) -- ", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "col-lg-12 fv-row mt-4"
}
const _hoisted_19 = { class: "card card-secondary" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-3" }, "Billing Setting")
], -1))
const _hoisted_22 = { class: "col-lg-12 row" }
const _hoisted_23 = { class: "col-lg-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Billed", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: ""
}, " -- Select (Harian, Mingguan, Bulanan) -- ", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col-lg-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Setiap", -1))
const _hoisted_29 = { class: "col-lg-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Jatuh Tempo", -1))
const _hoisted_31 = { class: "col-lg-6" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Price", -1))
const _hoisted_33 = { class: "col-lg-6 mb-8" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tax", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_36 = { class: "col-lg-12" }
const _hoisted_37 = { class: "d-flex justify-content-between align-items-center mb-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Feature Detail", -1))
const _hoisted_39 = { class: "accordion-item" }
const _hoisted_40 = ["id"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = ["data-bs-target", "aria-controls"]
const _hoisted_45 = ["id", "aria-labelledby"]
const _hoisted_46 = { class: "accordion-body" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Rincian ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 1,
  class: "text-center"
}
const _hoisted_53 = { class: "col-lg-4" }
const _hoisted_54 = { class: "card border" }
const _hoisted_55 = { class: "card-body" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "col-lg-12" }, "Price Plan preview")
], -1))
const _hoisted_57 = { class: "card border" }
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = { class: "text-center mb-8" }
const _hoisted_60 = { class: "fs-4" }
const _hoisted_61 = { class: "fs-1 text-info" }
const _hoisted_62 = {
  key: 0,
  class: "fs-6 billed-info"
}
const _hoisted_63 = { class: "list-unstyled" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-indicator me-3" }, null, -1))
const _hoisted_65 = { class: "menu-text" }
const _hoisted_66 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_67 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DayMonthPicker = _resolveComponent("DayMonthPicker")!
  const _component_AddFeaturesModal = _resolveComponent("AddFeaturesModal")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "price_title",
                          rules: _ctx.isRequired,
                          class: "form-control form-control-lg",
                          "model-value": _ctx.dataPricing.price_title,
                          "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataPricing.price_title) = $event))
                        }, null, 8, ["rules", "model-value"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "price_title",
                          class: "text-danger"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control form-control-lg",
                          type: "text",
                          placeholder: "",
                          name: "description",
                          autocomplete: "off",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataPricing.description) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.dataPricing.description]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_Field, {
                          as: "select",
                          class: "form-select",
                          rules: _ctx.isRequired,
                          name: "pricing-type",
                          modelValue: _ctx.dataPricing.price_type,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataPricing.price_type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceType, (item, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: index,
                                value: item.toLowerCase()
                              }, _toDisplayString(item), 9, _hoisted_17))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["rules", "modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "pricing-type",
                          class: "text-danger"
                        })
                      ]),
                      (
                      _ctx.dataPricing.price_type ===
                      _ctx.priceTypeEnum.RECURRING.toLowerCase()
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select",
                                      name: "billing-setting-billed",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataPricing.billing_setting.billed) = $event))
                                    }, [
                                      _hoisted_25,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billedType, (item, index) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: index,
                                          value: item.key
                                        }, _toDisplayString(item.value), 9, _hoisted_26))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.dataPricing.billing_setting.billed]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _hoisted_28,
                                    (
                                _ctx.dataPricing.billing_setting.billed ===
                                  _ctx.billedTypeEnum.DAY.toLowerCase() ||
                                _ctx.dataPricing.billing_setting.billed ===
                                  _ctx.billedTypeEnum.MONTH.toLowerCase()
                              )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            name: "billing-setting-billing-day",
                                            class: "form-control form-control-lg",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((
                                  _ctx.dataPricing.billing_setting.billing_day
                                ) = $event))
                                          }, null, 512), [
                                            [_vModelText, 
                                  _ctx.dataPricing.billing_setting.billing_day
                                ]
                                          ]),
                                          _createVNode(_component_ErrorMessage, { name: "billing-setting-billing-day" })
                                        ], 64))
                                      : (_openBlock(), _createBlock(_component_DayMonthPicker, {
                                          key: 1,
                                          modelValue: 
                                  _ctx.dataPricing.billing_setting.billing_day
                                ,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
                                  _ctx.dataPricing.billing_setting.billing_day
                                ) = $event))
                                        }, null, 8, ["modelValue"]))
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createVNode(_component_Field, {
                                      type: "text",
                                      name: "pricing-billing-duration",
                                      class: "form-control form-control-lg",
                                      modelValue: 
                                _ctx.dataPricing.billing_setting.billing_due_day
                              ,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
                                _ctx.dataPricing.billing_setting.billing_due_day
                              ) = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "price",
                          disabled: _ctx.dataPricing.price_type === _ctx.priceTypeEnum.FREE,
                          class: "form-control form-control-lg",
                          modelValue: _ctx.dataPricing.price,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataPricing.price) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "tax",
                          disabled: _ctx.dataPricing.price_type === _ctx.priceTypeEnum.FREE,
                          class: "form-control form-control-lg",
                          modelValue: _ctx.dataPricing.tax,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataPricing.tax) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          (_ctx.dataPricing.price_title !== '')
                            ? (_openBlock(), _createBlock(_component_AddFeaturesModal, {
                                key: 0,
                                onSave: _ctx.handleAddFeature,
                                "data-value": _ctx.features
                              }, null, 8, ["onSave", "data-value"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.features.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.features, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "accordion",
                                id: "accordionFlushExample",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("h2", {
                                    class: "accordion-header d-flex align-items-center mb-2 p-2",
                                    id: `flush-heading${index}`
                                  }, [
                                    _createElementVNode("a", {
                                      class: "symbol symbol-35px mx-2",
                                      "data-bs-toggle": "tooltip",
                                      title: "Hapus",
                                      style: {"cursor":"pointer"},
                                      onClick: ($event: any) => (_ctx.removeModule(index))
                                    }, _hoisted_43, 8, _hoisted_41),
                                    _createElementVNode("button", {
                                      class: "accordion-button collapsed",
                                      type: "button",
                                      "data-bs-toggle": "collapse",
                                      "data-bs-target": `#flush-collapse${index}`,
                                      "aria-expanded": "false",
                                      "aria-controls": `flush-collapse${index}`
                                    }, _toDisplayString(item.name), 9, _hoisted_44)
                                  ], 8, _hoisted_40),
                                  _createElementVNode("div", {
                                    id: `flush-collapse${index}`,
                                    class: "accordion-collapse collapse",
                                    "aria-labelledby": `flush-heading${index}`,
                                    "data-bs-parent": "#accordionFlushExample"
                                  }, [
                                    _createElementVNode("div", _hoisted_46, [
                                      (item.description)
                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_47, _toDisplayString(item.description), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                            _hoisted_49,
                                            _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                                            _hoisted_50
                                          ])),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.detail_modules, (detail, i) => {
                                        return (_openBlock(), _createElementBlock("ul", { key: i }, [
                                          (detail.module_status)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_51, _toDisplayString(detail.module_description), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ], 8, _hoisted_45)
                                ])
                              ]))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", _hoisted_52, "Tidak Ada data"))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("h3", _hoisted_60, _toDisplayString(_ctx.dataPricing.price_title === ""
                              ? "-"
                              : _ctx.dataPricing.price_title), 1),
                            _createElementVNode("h2", _hoisted_61, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.dataPricing.price)), 1),
                            (
                            _ctx.dataPricing.price_type ===
                            _ctx.priceTypeEnum.RECURRING.toLowerCase()
                          )
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_62, " Per " + _toDisplayString(_ctx.capitalizeBilled(_ctx.dataPricing.billing_setting.billed)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("ul", _hoisted_63, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.name,
                                class: "d-flex align-items-center mb-2"
                              }, [
                                _hoisted_64,
                                _createElementVNode("span", _hoisted_65, _toDisplayString(item.name), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/superadmin/master-feature/pricing')))
              }, " Batal "),
              _createElementVNode("button", _hoisted_67, _hoisted_70, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ], 64))
}